module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};



//////////////////
// WEBPACK FOOTER
// ./~/ganache-core/~/isarray/index.js
// module id = 613
// module chunks = 0 1 2